<template>
  <div>
    <div class="black_panel_cla">
      <div class="header-button-bar">
        <ZkButtonGroup :event="['add']"
                       :isGroup="true"
                       @add="add"></ZkButtonGroup>
      </div>
      <el-table :data="tableData"
                style="width: 100%">
        <el-table-column type="index"
                         width="40"></el-table-column>
        <el-table-column prop="code"
                         :label="$t('sysOption.code')"></el-table-column>

        <el-table-column prop="plainVal"
                         :label="$t('sysOption.plainVal')"
                         width="60"></el-table-column>

        <el-table-column prop="des"
                         :label="$t('sysOption.des')">
          <template slot-scope="scope">
            <el-popover trigger="hover"
                        placement="bottom">
              <p>{{ scope.row.des }}</p>
              <div slot="reference"
                   class="name-wrapper">
                <div style="white-space: nowrap;overflow:hidden;text-overflow:ellipsis">{{ scope.row.des }}</div>
              </div>
            </el-popover>
          </template>
        </el-table-column>

        <el-table-column prop="readonly"
                         :label="$t('sysOption.readonly')"
                         width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.readonly"
                  style="color:@themeColor">{{$t('sysOption.yes')}}</span>
            <span v-else style="color：#f56c6c">{{$t('sysOption.no')}}</span>
            <!-- {{scope.row.readonly}} -->
          </template>
        </el-table-column>
        <el-table-column prop="enable"
                         :label="$t('sysOption.enable')"
                         width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.enable"
                  style="color:@themeColor">{{$t('sysOption.yes')}}</span>
            <span v-else
                  style="color：#f56c6c">{{$t('sysOption.no')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="toCompany"
                         :label="$t('sysOption.tocompany')"
                         width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.toCompany"
                  style="color:@themeColor">{{$t('sysOption.yes')}}</span>
            <span v-else
                  style="color：#f56c6c">{{$t('sysOption.no')}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="createdDate"
                         :label="$t('common.createdDate')">
          <template slot-scope="scope">{{scope.row.createdDate*1000|dataFormat}}</template>
        </el-table-column>
        <el-table-column prop="modifiedDate"
                         :label="$t('common.modifiedDate')">
          <template slot-scope="scope">{{scope.row.modifiedDate*1000|dataFormat}}</template>
        </el-table-column>

        <el-table-column width="180px"
                         :label="this.$t('common.operation')">
          <template slot-scope="scope">
            <ZkButtonGroup :params="scope.row"
                           :event="['remove','update']"
                           :isGroup="true"
                           :onlyShowText="true"
                           @update="update"
                           @remove="remove"></ZkButtonGroup>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog :close-on-click-modal="false"
               :title="title"
               :visible.sync="dialogFormVisible"
               width="45%">
      <el-form ref="addRuleForm"
               :rules="rules"
               label-position="right"
               label-width="180px"
               :model="form">
        <el-form-item prop="code"
                      :label="$t('sysOption.code')">
          <el-input v-model="form.code"
                    autocomplete="off"
                    :placeholder="$t('sysOption.namePla')"></el-input>
        </el-form-item>

        <el-form-item prop="plainVal"
                      :label="$t('sysOption.plainVal')">
          <el-input v-model="form.plainVal"
                    autocomplete="off"
                    :placeholder="$t('sysOption.plainPla')"></el-input>
        </el-form-item>

        <el-form-item :label="$t('sysOption.des')">
          <el-input v-model="form.des"
                    autocomplete="off"
                    :placeholder="$t('sysOption.desPla')"></el-input>
        </el-form-item>

        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('sysOption.readonly')">
              <el-switch v-model="form.readonly"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('sysOption.enable')">
              <el-switch v-model="form.enable"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('sysOption.tocompany')">
          <el-switch v-model="form.toCompany"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{$t('common.cancel')}}</el-button>
        <el-button type="primary"
                   @click.stop="submitSave">{{$t('common.confirm')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as sysOptionsApi from '@/services/sysOptionsApi.js'
export default {
  data () {
    return {
      dialogFormVisible: false,
      isEdit: true,
      tableData: [],
      title: '',
      rules: {
        code: [
          {
            required: true,
            message: this.$t('sysOption.requireCode'),
            trigger: 'blur'
          }
        ],

        plainVal: [
          {
            required: true,
            message: this.$t('sysOption.requirePlainVal'),
            trigger: ['blur', 'change']
          }
        ]
      },
      form: {
        des: '',
        code: '',
        createdDate: '',
        modifiedDate: '',
        readonly: true,
        enable: true,
        toCompany: true,
        plainVal: ''
      }
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    add () {
      this.title = this.$t('sysOption.add')
      this.isEdit = false
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.addRuleForm.resetFields()
        this.form.code = ''
        this.form.plainVal = ''
        this.form.des = ''
        this.form.readonly = true
        this.form.enable = true
        this.form.toCompany = true
      })
    },
    remove (row) {
      this.$confirm(
        this.$t('common.confirmDeleteRecordTip'),
        this.$t('common.confirmDelete'),
        {
          confirmButtonText: this.$t('common.yes'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          let params = {
            id: row.id
          }
          sysOptionsApi
            .remove(params)
            .then((data) => {
              if (data.code === '00000000') {
                this.load()
                this.dialogFormVisible = false
              } else {
                this.errorMessage(data.message)
              }
            })
            .catch((e) => {
              this.errorMessage()
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelDelete')
          })
        })
    },
    update (row) {
      this.dialogFormVisible = true
      this.title = this.$t('sysOption.update')
      this.isEdit = true
      this.$nextTick(() => {
        this.$refs.addRuleForm.resetFields()
        this.form.code = row.code
        this.form.id = row.id
        this.form.plainVal = row.plainVal
        this.form.des = row.des
        this.form.readonly = row.readonly
        this.form.enable = row.enable
        this.form.toCompany = row.toCompany
      })
    },
    submitSave () {
      if (this.isEdit) {
        // 编辑
        this.updateSubmit()
      } else {
        // 新增
        this.addSubmit()
      }
    },
    addSubmit () {
      this.$refs.addRuleForm.validate((valid) => {
        if (valid) {
          //
          sysOptionsApi
            .add(this.form)
            .then((data) => {
              if (data.code === '00000000') {
                this.load()
                this.dialogFormVisible = false
              } else {
                this.errorMessage(data.message)
              }
            })
            .catch((e) => {
              this.errorMessage()
            })
        }
      })
    },
    updateSubmit () {
      this.$refs.addRuleForm.validate((valid) => {
        if (valid) {
          //
          sysOptionsApi
            .update(this.form)
            .then((data) => {
              if (data.code === '00000000') {
                this.load()
                this.dialogFormVisible = false
              } else {
                this.errorMessage(data.message)
              }
            })
            .catch((e) => {
              this.errorMessage()
            })
        }
      })
    },
    load () {
      sysOptionsApi
        .query()
        .then((data) => {
          if (data.code === '00000000') {
            this.tableData = data.payload.results
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch((data) => {
          this.errorMessage()
        })
    }
  }
}
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/modules/sysOptions/sysOptions.vue